// extracted by mini-css-extract-plugin
export default {"label":"a6XoXK"};